<template>
    <b-container>
        <h1>Manage Inbox</h1>
        <b-form-group
      label="Inbox Subject"
      label-for="subject"
      description="This will show in the left sidebar"
      class="mb-3"
    >
      <b-form-input
        id="subject"
        v-model="subject"
        placeholder="Name of Inbox"
      ></b-form-input>
    </b-form-group>
        <b-form-group class="mb-3">
            <label for="body" class="font-weight-bold">Description</label>
            <b-form-textarea v-model="body" id="body" required name="body" placeholder="Description"></b-form-textarea>
        </b-form-group>

        <b-form-group class="mb-3">
            <label for="users" class="font-weight-bold">Users</label>
            <b-form-checkbox-group
                id="users"
                v-model="participants"
                :options="users"
                name="users"
                stacked
            ></b-form-checkbox-group>
        </b-form-group>


        <b-button @click="onSubmit" id="submitButton" variant="primary">{{ button_label }}</b-button>
    </b-container>
</template>

<script>

    import UserDataService from '@/services/UserDataService'
    import InboxDataService from '@/services/InboxDataService'

    export default {
        data() {
            return {
                subject: '',
                body: '',
                users: [],
                participants: [],
                action: 'create',
                button_label: 'Start Chatting!'
            }
        },
        created() {
            UserDataService.getActiveUsers()
                .then(response => {
                    this.users = response.data;
                    this.users.forEach(user => {
                        if(user.text == localStorage.getItem('name')) {
                            this.participants.push(user.value)
                        }
                    })
                })
                .catch(e => {
                    console.log(e);
                });


                if(this.$route.params.id) {
                    this.action = 'update'
                    this.button_label = 'Update Inbox'
                    InboxDataService.getInbox(this.$route.params.id)
                        .then(response => {
                            this.subject = response.data.subject      
                            InboxDataService.participants(this.$route.params.id).then((participants) => {
                                
                                participants.data.forEach(participant => {
                                    this.participants.push(participant.id)
                                })

                            })
                            
                        })
                        .catch(e => {
                            console.log(e);
                        });
                }

        },
        methods: {
            onSubmit() {
                document.getElementById('submitButton').disabled = true

                if(this.action == 'update') {
                    InboxDataService.update(this.$route.params.id, {
                        subject: this.subject,
                        body: this.body,
                        participants: this.participants
                    }).then(() => {
                        this.$emit("alert", 
                        { variant: "success", message: `<a href="/inbox/message/${this.$route.params.id}">Inbox ${this.subject}</a> updated successfully` });  
                    })
                } else {

                InboxDataService.create({
                    subject: this.subject,
                    body: this.body,
                    participants: this.participants
                }).then((inbox) => {
                    this.$emit("alert", 
                    { variant: "success", message: `<a href="/inbox/message/${inbox.id}">Inbox ${inbox.subject}</a> created successfully` });  
                })

                }
            },
            onReset() {
                this.message = ''
            }
        }
    }
</script>